import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ESamparkComponent } from './e-sampark/e-sampark.component';

const routes: Routes = [
  { path: "", redirectTo: "eSampark", pathMatch: "full" },
{ path: "eSampark", component: ESamparkComponent },
//{ path: "eSampark/:tokenId", component: ESamparkComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
